export const detailsNav = [
  { label: "Overview", href: "#overview", id: "overview" },
  { label: "Itinerary", href: "#itinerary", id: "itinerary" },
  { label: "Accommodation", href: "#accommodation", id: "accommodation" },
  { label: "Inclusions/Exclusions", href: "#inclusions", id: "inclusions" },
  {
    label: "Booking Policy",
    href: "#cancellationPolicy",
    id: "cancellationPolicy",
  },
];
